import * as React from "react";

import usePage from "./use-page";

export default function useProperties() {
  const pageContext = usePage();

  return React.useMemo(() => {
    const { page, updateColors, updateFont, updateTheme } = pageContext;
    return {
      updateColors,
      updateFont,
      updateTheme,
      ...page.properties,
    };
  }, [pageContext]);
}
